module.exports = __webpack_public_path__ + "static/media/new_idea.31113504.png";